import type { ReactNode } from 'react';
import { cn } from './lib/cn';

export function EmptyState({
  icon,
  title,
  description,
  actions,
  className,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-2xl border border-dashed bg-card px-6 py-14 text-center',
        className
      )}
    >
      {icon && (
        <div className='grid h-16 w-16 place-items-center rounded-full bg-brand-navy-100 text-brand-navy'>
          {icon}
        </div>
      )}
      <h3 className='mt-4 text-lg font-semibold text-brand-navy'>{title}</h3>
      {description && (
        <p className='mt-1 max-w-md text-sm text-muted-foreground'>{description}</p>
      )}
      {actions && (
        <div className='mt-5 flex flex-wrap items-center justify-center gap-2'>
          {actions}
        </div>
      )}
    </div>
  );
}
